import { Injectable, signal } from '@angular/core';

export interface NavigationAction {
  label: string;
  action: () => void;
  disabled: boolean;
  loading?: boolean;
  testId?: string;
}

/**
 * Service to handle navigation actions like the Save button in quiz forms
 * This allows components to register an action (like Save) that will
 * appear in the central navigation bar between Previous and Next buttons
 */
@Injectable({
  providedIn: 'root'
})
export class NavigationActionService {
  // Use a signal for the middle action button
  private _middleAction = signal<NavigationAction | null>(null);
  public middleAction = this._middleAction.asReadonly();

  /**
   * Set the middle action button in the navigation bar
   * @param action The action configuration or null to clear
   */
  setMiddleAction(action: NavigationAction | null): void {
    this._middleAction.set(action);
  }

  /**
   * Clear the middle action button from the navigation bar
   */
  clearMiddleAction(): void {
    this._middleAction.set(null);
  }
}
